import React, { useCallback, useContext, useEffect, useRef } from 'react';
import { getText } from "../../libs/utils";
import API from '../../libs/API';
import { Box, Container, Typography } from '@mui/material';
import { NvWidget, SumSubWidget } from '../perform_order/OrderKYC';
import { UserDataContext } from '../../App';
import { useNavigate } from 'react-router-dom';
import { ContentBox } from '../../libs/theme';

export default function CommonKYC() {
  const [kycData, setKycData] = React.useState(null);
  const userData = useContext(UserDataContext);
  const navigate = useNavigate();
  const intervalRef = useRef(null);


  const createSession = async () => {
    try {
      const response = await API.createKYCSession(null);
      if (response.status === 200) {
        setKycData(response.data?.session);
      }
    } catch (error) {
      console.error("Error creating KYC session:", error);
    }
  };

  const getUserProfile = useCallback(async () => {
    const data = await API.getProfileData(userData.token);
    if (data.success) {
      userData.setHasKyc(data.data.hasKyc);

      // The provider can report completion before the backend has persisted
      // it. Keep polling until KYC is actually reflected in the profile.
      if (data.data.hasKyc && intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }

    return data;
  }, [userData.token, userData.setHasKyc]);

  useEffect(() => {
    createSession();
    intervalRef.current = setInterval(() => {
      getUserProfile();
    }, 15000);
    getUserProfile();

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [getUserProfile]);

  const handleWidgetClose = useCallback(() => {
    console.log("KYC widget closed");
    navigate('/');
  }, [navigate]);

  const handleWidgetSuccess = useCallback((payload) => {
    console.log("KYC completed successfully", payload);
    getUserProfile();
    navigate('/');
  }, [getUserProfile, navigate]);

  return (
    <Container>
      <ContentBox>
        <Box >
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }} mb={0}>
              <Typography variant="h4">{getText('comKYCHeader')}</Typography>
            </Box>
            <Typography variant="regularCaption" >{getText('comKYCInstruction')}</Typography>
            <Box mt={3}>
              {kycData?.iframeUrl && <iframe
                title="KYC Verification"
                src={kycData ? kycData.iframeUrl : ''}
                allow='camera; microphone'
                width="100%"
                height="650px"
                style={{ border: 'none' }}
              >
              </iframe>}
              {kycData?.service?.toLowerCase() == "neurovision" && <NvWidget
                schema={kycData?.data?.schemaId}
                clientKey={kycData?.data?.clientKey}
                isOpen={true}
                onClose={handleWidgetClose}
                onSuccess={handleWidgetSuccess}
              />}
              {kycData?.service?.toLowerCase() == "sumsub" && <SumSubWidget accessToken={kycData?.data?.accessToken} onApplicantVerificationCompleted={getUserProfile} />}
            </Box>
          </Box>
        </Box>
      </ContentBox>
    </Container>
  );
}
